module.exports = __webpack_public_path__ + "images/160_4096.jpg";